export default __webpack_public_path__ + "static/us-consumer-discounts-devices-4d03a21c9c5ca704d80259aa6697da96.png";